const formatCureny3F = (value) => {
  // Remove all non-digit characters
  const onlyNums = value.replace(/\D/g, "");

  // Add commas for thousands, millions, etc.
  return onlyNums.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default formatCureny3F;
